export enum TermTypes {
    FirstTerm = 1,
    SecondTerm = 2
}

export const TermEnum = {
  FIRST_TERM: 'firstTerm',
  SECOND_TERM: 'secondTerm'
}
